import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { GetTopAdvisorsAction, GetTopAdvisorsReviewsAction } from 'components/features/coaching/advisorStore/actions/advisorLandingPageActions'

export const topAdvisorsReducer: Reducer<AdvisorDataState['topAdvisors']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GetTopAdvisorsAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          isLoading: true,
          errorCode: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
        }
      }

      return {
        ...prevState,
        isLoading: false,
        errorCode: null,
        data: action.payload.response.map((item) => item.uid),
      }
    }
  }
  return prevState
}

export const topReviewsReducer: Reducer<AdvisorDataState['topReviews']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GetTopAdvisorsReviewsAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          isLoading: true,
          errorCode: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
        }
      }

      return {
        ...prevState,
        isLoading: false,
        errorCode: null,
        data: action.payload.response.map((item) => item.uid),
      }
    }
  }
  return prevState
}
